export default {
  appName: "Talium Conseil",
  showTopHeader: false,
  showLang: true,
  showSearch: false,
  email: "contact@taliumconseil.com",
  contact: "(+226) 69-09-09-37 / 66-09-09-37",
  firstContact: "(+226) 69-09-09-37",
  secondContact: "(+227) 80-33-22-27",
  thirdContact: "",
  facebook: "Talium Conseil",
  instagram: "Talium Conseil",
  linkedIn: "Talium Conseil",
  twitter: "Talium Conseil",
  web: "www.http://taliumconseil.com",
  apiUrl: "https://adive-backend-api.warilo.com/api",
  //apiUrl: 'http://localhost:1337/api',
  availability: "Lun - Ven : 08H - 18H | Sam : 08H - 13H",
};
